import { useSafeState } from 'ahooks';
import { Image } from 'antd';
import Swiper from '@/components/Swiper';
import pageData from '../common/data.json';
import styles from './index.module.less';

function CityPC() {
  const [parkVisible, setParkVisible] = useSafeState({
    env: false,
    activity: false,
    current: 0,
  });

  const renderProfile = () => (
    <div className={styles.profile}>
      <div className={styles.profile__info}>
        <div className={styles.profile__title}>{pageData.profile.label}</div>
        <div className={styles.profile__text}>{pageData.profile.content}</div>
      </div>
      <img src={pageData.profile.bgUrl} alt="" className={styles.profile__bg} />
    </div>
  );

  const renderBrief = () => (
    <div className={styles.brief}>
      <div className={styles.content}>{pageData.brief.content}</div>
      <div className={styles.brief__img}>
        {pageData.brief.imgList.map((imgUrl, index) => (
          <img key={index} src={imgUrl} alt="" className={styles.brief__img} />
        ))}
      </div>
    </div>
  );

  const renderCamp = () => (
    <div className={styles.station}>
      <div className={styles.title}>{pageData.camp.title}</div>
      <img src={pageData.camp.imgList[0]} alt="" className={styles.station__img} />
      <div className={styles.content}>{pageData.camp.content1}</div>
    </div>
  );
  const renderTravel = () => (
    <div className={styles.station}>
      <div className={styles.title}>{pageData.travel.title}</div>
      <img src={pageData.travel.imgList[0]} alt="" className={styles.station__img} />
      <div className={styles.content}>{pageData.travel.content1}</div>
    </div>
  );
  const renderWeek = () => (
    <div className={styles.station}>
      <div className={styles.title}>{pageData.week.title}</div>
      <img src={pageData.week.logo} alt="" className={styles.station__img__logo} />
      <div className={styles.content}>{pageData.week.content1}</div>
      <img src={pageData.week.imgList[0]} alt="" className={styles.station__img} />
      <div className={styles.content}>{pageData.week.content2}</div>
      <img src={pageData.week.imgList[1]} alt="" className={styles.station__img} />
      <div className={styles.content}>{pageData.week.content3}</div>
      <img src={pageData.week.imgList[2]} alt="" className={styles.station__img} />
    </div>
  );

  return (
    <section className={styles.city}>
      {renderProfile()}
      <div className={styles.city__content}>
        {renderBrief()}

        {renderTravel()}
        {renderCamp()}
        {renderWeek()}
      </div>
    </section>
  );
}

export default CityPC;
